import { getFirestore, doc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

export const db        = getFirestore();
export const functions = getFunctions();

export const approvePost         = httpsCallable(functions, "approveBlogPost");
export const regeneratePost      = httpsCallable(functions, "regenerateBlogPost");
// On-demand quality repair. Runs deterministic fixes plus one Gemini pass, so it
// needs the same raised timeout as refreshBlogContent below — at the SDK's 70s
// default this rejects mid-run and surfaces a spurious "deadline-exceeded" while
// the server is still working. Matches the 500s server budget (extTimeout).
export const fixPostQuality      = httpsCallable(functions, "fixBlogPostQuality", { timeout: 540000 });
export const deletePost          = httpsCallable(functions, "deletePendingBlogPost");
export const deleteApprovedPost  = httpsCallable(functions, "deleteBlogPost");
export const editImageFn         = httpsCallable(functions, "editBlogImage");
export const regenImageFn        = httpsCallable(functions, "regenerateBlogImage");
export const createPost          = httpsCallable(functions, "createBlogPost");
// Published posts are read from Sanity (source of truth), not Firestore.
export const listPublishedPosts  = httpsCallable(functions, "listPublishedPosts");
// SEO keyword clusters — manual trigger for the monthly DataForSEO refresh.
// Pass { dryRun: true } to preview the diff without writing.
export const refreshKeywordClusters = httpsCallable(functions, "refreshKeywordClustersNow");
// A real refresh runs for minutes (Search Console + Gemini), so useContentRefresh
// dispatches it without awaiting and tracks blog_tasks/{taskId} instead. The
// raised timeout still matters: at the SDK's 70s default this promise would
// reject mid-run and surface a spurious "deadline-exceeded" while the server
// was still working. Matches the 500s server budget (extTimeout in init.js).
export const refreshBlogContent     = httpsCallable(functions, "refreshBlogContentNow", { timeout: 540000 });

export function pendingRef(docId) {
  return doc(db, "blog_posts_pending", docId);
}

export function taskRef(taskId) {
  return doc(db, "blog_tasks", taskId);
}

export function formatDate(iso) {
  try {
    return new Date(iso + "T00:00:00Z").toLocaleDateString("en-US", {
      year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
    });
  } catch { return iso || ""; }
}
